import { IconButton, Spacer } from '@sparemin/blockhead';
import React from 'react';
import FontAwesome from 'components/FontAwesome';

import {
  useFileArchiveInfo,
  useIsEditDisabled,
  useIsRegeneratingProject,
} from './ProjectPreviewModalContext';
import ProjectPreviewModalEditOptions from './ProjectPreviewModalEditOptions';
import ProjectPreviewModalRestoreButton from './ProjectPreviewModalRestoreButton';
import { ProjectPreviewModalAction } from './types';
import { block } from './utils';

export interface ProjectPreviewModalActionsProps {
  onAction: (action: ProjectPreviewModalAction) => void;
}

const ProjectPreviewModalActions: React.FC<ProjectPreviewModalActionsProps> = ({
  onAction,
}) => {
  const { isRestoreInProgress } = useFileArchiveInfo();
  const isRegeneratingProject = useIsRegeneratingProject();
  const isEditDisabled = useIsEditDisabled();

  return (
    <Spacer space="16px" orientation="horizontal" align="center">
      {!isRestoreInProgress && (
        <>
          <IconButton
            isDisabled={isRegeneratingProject}
            className={block('round-button')}
            onPress={() => onAction('delete')}
          >
            <FontAwesome icon="trash-alt" />
          </IconButton>

          <IconButton
            isDisabled={isEditDisabled}
            className={block('round-button')}
            onPress={() => onAction('copy')}
          >
            <FontAwesome regular icon="copy" />
          </IconButton>

          <ProjectPreviewModalEditOptions />
        </>
      )}

      <ProjectPreviewModalRestoreButton onAction={onAction} />
    </Spacer>
  );
};

export default ProjectPreviewModalActions;
